// Mock data for psychologist website - Лазарева Ирина Антоновна

export const psychologistInfo = {
  name: "Лазарева Ирина Антоновна",
  title: "Клинический психолог",
  experience: 30,
  consultations: 3500,
  clients: 1200,
  phone: "+7 (927) 680-52-20",
  email: "info@dririnalazareva.com",
  onlineConsultationLabel: "Видеоконсультации из любой точки мира",
  address: "г. Москва, ул. Тверская, д. 12, офис 45",
  workingHours: {
    weekdays: "по договоренности",
    saturday: "по договоренности",
    sunday: "по договоренности"
  },
  social: {
    telegram: "https://t.me/IrinAntonovna",
    whatsapp: "https://wa.me/79276805220",
    vk: "https://vk.com/i.a.lazareva"
  }
};

export const heroContent = {
  subtitle: "Профессиональная психологическая помощь",
  title: "Путь к гармонии начинается с первого шага",
  description: "Помогаю взрослым и детям обрести внутренний баланс, преодолеть кризисы и построить счастливые отношения. Индивидуальный подход и конфиденциальность гарантированы.",
  stats: [
    { number: "30+", label: "Лет опыта" },
    { number: "3500+", label: "Консультаций" },
    { number: "1200+", label: "Клиентов" }
  ]
};

export const aboutContent = {
  title: "Обо мне",
  subtitle: "Ваш надёжный проводник к психологическому благополучию",
  description: "Я — Лазарева Ирина Антоновна, клинический психолог с более чем 30-летним опытом работы. Специализируюсь на помощи людям всех возрастов в преодолении жизненных трудностей, эмоциональных кризисов и построении гармоничных отношений.",
  additionalInfo: "Мой подход основан на сочетании классических методов психотерапии и современных научно доказанных техник. Каждый клиент для меня уникален, и я подбираю индивидуальную стратегию работы.",
  highlights: [
    "Индивидуальный подход к каждому клиенту",
    "Работа с детьми, подростками и взрослыми",
    "Онлайн и офлайн консультации",
    "Полная конфиденциальность"
  ],
  image: "/images/about-hero.webp"
};

export const services = [
  {
    id: 1,
    icon: "User",
    serviceValue: "individual",
    title: "Индивидуальная терапия",
    description: "Работа с личными проблемами, тревогой, депрессией, самооценкой и жизненными кризисами.",
    details: ["Тревожные расстройства", "Депрессия", "Низкая самооценка", "Проблемы в отношениях"]
  },
  {
    id: 2,
    icon: "Baby",
    serviceValue: "child",
    title: "Детская психология",
    description: "Помощь детям в адаптации, преодолении страхов, проблем в обучении, поведении и социализации.",
    details: ["Адаптация к школе/саду", "Детские страхи", "Гиперактивность", "Проблемы с обучением"]
  },
  {
    id: 3,
    icon: "Users",
    serviceValue: "family",
    title: "Семейная терапия",
    description: "Восстановление отношений в семье, работа с конфликтами, помощь в кризисных ситуациях.",
    details: ["Семейные конфликты", "Развод", "Отношения родителей и детей", "Кризис в браке"]
  },
  {
    id: 4,
    icon: "Heart",
    serviceValue: "crisis",
    title: "Кризисная помощь",
    description: "Экстренная психологическая поддержка в острых жизненных ситуациях и травматических событиях.",
    details: ["Потеря близких", "Травматические события", "Острый стресс", "Жизненные перемены"]
  },
  {
    id: 5,
    icon: "Shield",
    serviceValue: "suicide",
    title: "Суицидальный кризис",
    description: "Профессиональная помощь в ситуациях суицидального риска. Конфиденциально и безопасно.",
    details: ["Суицидальные мысли", "Самоповреждение", "Экзистенциальный кризис", "Поддержка близких"]
  },
  {
    id: 6,
    icon: "Building",
    serviceValue: "corporate",
    title: "Корпоративная психология",
    description: "Психологическое сопровождение компаний, тренинги, работа с выгоранием сотрудников.",
    details: ["Профессиональное выгорание", "Командообразование", "Конфликты на работе", "Стресс-менеджмент"]
  }
];

export const certificates = [
  {
    id: 1,
    title: "Психологический факультет",
    institution: "Открытый социальный университет, г. Москва",
    specialization: "Квалификация - психолог",
    year: "1998"
  },
  {
    id: 2,
    title: "Медицинский психолог",
    institution: "ФГБУ ДПО СПбИУВЭК Минтруда России",
    specialization: "Специализация: медицинский психолог",
    year: "1998"
  },
  {
    id: 3,
    title: "Социально-психологическая реабилитация",
    institution: "ФГБУ ДПО СПбИУВЭК Минтруда России",
    specialization: "Специализация: социально-психологическая реабилитация больных и инвалидов",
    year: "1999"
  },
  {
    id: 4,
    title: "Экстремальная психология",
    institution: "Вологодский институт права и экономики ФСИН России",
    specialization: "Программа по экстремальной психологии",
    year: "2009"
  },
  {
    id: 5,
    title: "Арт-терапия и гештальт-подход",
    institution: "Межрегиональный открытый социальный институт",
    specialization: "Арт-терапия и гештальт-подход в деятельности практического психолога",
    year: "2012"
  },
  {
    id: 6,
    title: "Системные расстановки",
    institution: "Дополнительное профессиональное обучение",
    specialization: "Теория и практика системных расстановок (семейных, организационных)",
    year: "2009"
  },
  {
    id: 7,
    title: "Семейная психотерапия",
    institution: "Дополнительное профессиональное обучение",
    specialization: "Системно-феноменологический подход в практике семейной психотерапии",
    year: "2013"
  },
  {
    id: 8,
    title: "Коррекция пищевого поведения",
    institution: "Институт практической психологии \"Иматон\"",
    specialization: "Психологическая коррекция пищевого поведения",
    year: "2016"
  },
  {
    id: 9,
    title: "Психодиагностические и психокоррекционные системы",
    institution: "Сертификационные программы",
    specialization: "Применение систем и оборудования: Био-мышь, Psihometric Expert, комплексы БОС, полиграфическое обследование и детекция лжи",
    year: "Сертификаты"
  }
];

export const pricing = [
  {
    id: 1,
    name: "Первичная консультация",
    serviceValue: "primary",
    price: "45 USD",
    duration: "60 минут",
    description: "Знакомство, диагностика, определение запроса",
    features: [
      "Диагностическая беседа",
      "Определение целей терапии",
      "План работы",
      "Рекомендации"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Семейная консультация",
    serviceValue: "family",
    price: "80 USD",
    duration: "90 минут",
    description: "Работа с парой или семьёй",
    features: [
      "Работа с 2-4 участниками",
      "Медиация конфликтов",
      "Улучшение коммуникации",
      "Семейные упражнения"
    ],
    popular: false
  },
  {
    id: 3,
    name: "Индивидуальная консультация",
    serviceValue: "online",
    price: "55 USD",
    duration: "60 минут",
    description: "Видеоконсультация из любой точки мира",
    features: [
      "Глубинная проработка",
      "Индивидуальные техники",
      "Домашние задания",
      "Поддержка между сессиями"
    ],
    popular: true
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Анна М.",
    role: "Менеджер, 34 года",
    location: "Москва",
    text: "Обратилась из-за сложного периода в отношениях: много обид, ссор, чувство, что меня не слышат. Раньше я либо молчала, либо срывалась. На сессиях мы учились выстраивать границы и говорить о своих потребностях без чувства вины. Это было не \"быстрое решение\", но очень глубоко и по делу. Сейчас я намного лучше понимаю себя, стало меньше конфликтов, и главное - появилось ощущение опоры внутри.",
    rating: 5
  },
  {
    id: 2,
    name: "Дмитрий К.",
    role: "Предприниматель, 42 года",
    location: "Москва",
    text: "Обратился из-за выгорания: не было мотивации, всё раздражало, даже отдых не помогал. После нескольких сессий стало легче, а позже получилось восстановиться и изменить подход к работе. Появилось понимание, где я перегружаю себя и почему постоянно игнорировал усталость. Сейчас лучше чувствую свои границы, распределяю нагрузку и не довожу себя до полного истощения.",
    rating: 5
  },
  {
    id: 3,
    name: "Елена С.",
    role: "Мама двоих детей",
    location: "Москва",
    text: "Обращались из-за сложностей с сыном: закрытость, вспышки раздражения, постоянные конфликты дома. Было чувство, что мы совсем потеряли контакт. На консультациях получили не только поддержку, но и конкретные инструменты, как выстраивать диалог без скандалов. Изменения были не за один день, но постепенно атмосфера в семье стала спокойнее, сын начал больше говорить и меньше уходить в протест. Очень благодарны за бережный и профессиональный подход.",
    rating: 5
  },
  {
    id: 4,
    name: "Михаил В.",
    role: "IT-специалист, 29 лет",
    location: "Москва",
    text: "После сильного стресса начались приступы паники, особенно в транспорте и в людных местах. Было страшно, что это никогда не закончится. На консультациях я получил понятный план, как действовать в моменте, и постепенно мы проработали причины. Мне понравился спокойный, профессиональный подход - без давления и \"магического мышления\". Сейчас приступов почти нет, и даже если тревога поднимается, я понимаю, как с этим справляться.",
    rating: 5
  },
  {
    id: 5,
    name: "Ирина П.",
    role: "Дизайнер, 31 год",
    location: "Москва",
    text: "Очень откликнулся бережный и одновременно структурный подход. На встречах не было давления, но при этом всегда оставалась ясность, куда мы идем и зачем. Уже после первых сессий появилось чувство внутренней опоры, а со временем - понятный план, как двигаться дальше в жизни и в работе.",
    rating: 5
  },
  {
    id: 6,
    name: "Наталья К.",
    role: "HR-менеджер, 38 лет",
    location: "Москва",
    text: "Обратилась с тревогой и перфекционизмом: постоянно жила в напряжении, боялась ошибиться и не могла \"выключить\" внутреннего критика. На сессиях мы разобрали, откуда это идет, и я получила конкретные техники, которые можно применять в обычной жизни. Постепенно стало меньше тревоги, появилось больше уверенности и спокойствия в ежедневных решениях.",
    rating: 5
  },
  {
    id: 7,
    name: "Сергей Л.",
    role: "Архитектор, 40 лет",
    location: "Москва",
    text: "Пришел в состоянии апатии: ничего не радовало, не было сил и мотивации даже на привычные задачи. Терапия помогла постепенно вернуть контакт с собой и снова почувствовать интерес к работе и к жизни в целом. Понравилось, что процесс шел в моем темпе, без резких \"рывков\". Очень признателен за поддержку и профессионализм.",
    rating: 5
  },
  {
    id: 8,
    name: "Полина Ж.",
    role: "Маркетолог, 27 лет",
    location: "Москва",
    text: "Пришла с запросом по отношениям, потому что долго находилась в повторяющемся сценарии боли и непонимания. На консультациях впервые почувствовала, что меня действительно слышат и не оценивают. Мы спокойно разобрали мои реакции, границы и ожидания, и я стала лучше понимать себя в контакте с другими. Это дало и внутреннее облегчение, и более зрелый взгляд на отношения.",
    rating: 5
  },
  {
    id: 9,
    name: "Кирилл А.",
    role: "Юрист, 35 лет",
    location: "Москва",
    text: "На фоне работы был сильный стресс: постоянное напряжение, раздражительность и ощущение, что я \"на пределе\". В терапии мы разобрали, что усиливает мою нагрузку, и как выстраивать границы без чувства вины. После встреч стало проще управлять эмоциями, яснее формулировать свои потребности и не доводить себя до эмоционального истощения.",
    rating: 5
  },
  {
    id: 10,
    name: "Ольга Р.",
    role: "Преподаватель, 44 года",
    location: "Москва",
    text: "Больше всего понравились деликатность, глубина и уважительное отношение к моему состоянию. Я проходила непростой период, и на сессиях удалось не просто \"выговориться\", а реально прожить его более экологично. Постепенно вернулись силы, ясность и ощущение, что опора снова внутри меня, а не только снаружи.",
    rating: 5
  },
  {
    id: 11,
    name: "Алексей Д.",
    role: "Инженер, 33 года",
    location: "Москва",
    text: "До начала терапии я много сомневался и не понимал, чего хочу дальше - в личной жизни и в работе. На консультациях появилась ясность и внутренний фокус: стало легче принимать решения и не метаться между крайностями. Очень ценю баланс между поддержкой и конкретными шагами, который помог не застрять в теории, а перейти к действиям.",
    rating: 5
  },
  {
    id: 12,
    name: "Мария Т.",
    role: "Фотограф, 29 лет",
    location: "Москва",
    text: "Обращалась с запросом на самооценку и тревогу: часто сравнивала себя с другими и жила с чувством \"недостаточности\". В процессе работы научилась мягче относиться к себе, замечать свои сильные стороны и не обесценивать достижения. Сейчас чувствую себя заметно устойчивее и спокойнее, даже в сложных ситуациях.",
    rating: 5
  },
  {
    id: 14,
    name: "Глеб С.",
    role: "Продакт-менеджер, 30 лет",
    location: "Москва",
    text: "Пришел с тревожностью и признаками выгорания: сложно было концентрироваться, все казалось тяжелым. В терапии мы выстроили более устойчивый ритм жизни и пересобрали приоритеты. Стало легче планировать дела, снизилось внутреннее напряжение, и появилось ощущение, что ресурс снова возвращается.",
    rating: 5
  },
  {
    id: 15,
    name: "Юлия В.",
    role: "SMM-специалист, 26 лет",
    location: "Москва",
    text: "Для меня ключевым результатом стало то, что я смогла выстроить границы и перестала постоянно винить себя за все вокруг. Это было непросто, но благодаря поддержке и четкой работе шаг за шагом получилось изменить привычные реакции. Сейчас чувствую больше уважения к себе и меньше внутренней вины.",
    rating: 5
  },
  {
    id: 16,
    name: "Андрей Г.",
    role: "Финансовый аналитик, 41 год",
    location: "Санкт-Петербург",
    text: "Онлайн-формат оказался очень удобным и при этом не менее эффективным, чем очные встречи. Я получил практичные рекомендации, которые реально работают в повседневных ситуациях. За несколько недель заметила ощутимые изменения: меньше тревоги, больше ясности и спокойствия в решениях.",
    rating: 5
  },
  {
    id: 17,
    name: "Лидия М.",
    role: "Маркетинг-директор, 39 лет",
    location: "Лондон",
    text: "Работали онлайн в другом часовом поясе, и все было организовано очень комфортно. Я переживала, что дистанционный формат будет \"не тем\", но в итоге получила глубокую и системную поддержку. Сейчас чувствую себя гораздо устойчивее эмоционально и лучше справляюсь со стрессом.",
    rating: 5
  },
  {
    id: 18,
    name: "Егор П.",
    role: "Разработчик, 32 года",
    location: "Торонто",
    text: "Пришел с паническими атаками и постоянным страхом, что это повторится в любой момент. На сессиях получил не только поддержку, но и четкое понимание, как действовать в приступе и как снижать общий уровень тревоги. Постепенно стало легче, вернулось ощущение контроля и уверенности, что из этого состояния можно выйти.",
    rating: 5
  },
  {
    id: 19,
    name: "Дарья К.",
    role: "Менеджер проектов, 28 лет",
    location: "Мельбурн",
    text: "Релокация оказалась сложнее, чем я ожидала: бессонница, постоянное напряжение и ощущение, что я “не на своём месте”. Работа с психологом помогла пережить этот этап спокойнее и вернуть ощущение контроля над жизнью. Мы разобрали, как адаптироваться к новому ритму без давления на себя и чувства вины. Постепенно ушла внутренняя тревога, и появилось больше уверенности в том, что я справлюсь с этим периодом.",
    rating: 5
  },
  {
    id: 20,
    name: "Алина Ш.",
    role: "Офис-менеджер, 36 лет",
    location: "Кипр",
    text: "Сессии помогли разобраться в сложных отношениях с близкими и увидеть, где я теряю себя в этом контакте. Мы проработали тревожность, реактивность и способы более спокойного общения. В результате стало меньше конфликтов, больше понимания своих границ и заметно спокойнее внутри.",
    rating: 5
  }
];

export const faqItems = [
  {
    id: 1,
    question: "Как проходит первая консультация?",
    answer: "Первая консультация — это знакомство. Мы обсуждаем ваш запрос, я задаю уточняющие вопросы, провожу первичную диагностику. Вместе определяем цели терапии и составляем примерный план работы. Вы можете задать любые вопросы о методах и процессе."
  },
  {
    id: 2,
    question: "Сколько сессий нужно для результата?",
    answer: "Количество сессий зависит от запроса. Для решения конкретной проблемы может хватить 5-10 встреч. Глубинная терапия обычно занимает 3-6 месяцев при регулярных встречах раз в неделю. Мы обсудим это индивидуально."
  },
  {
    id: 3,
    question: "Вы работаете онлайн?",
    answer: "Да, я провожу онлайн-консультации через Zoom, Telegram или WhatsApp. Это удобно для клиентов из других городов или тех, кто предпочитает комфорт домашней обстановки. Эффективность онлайн-терапии не уступает очной."
  },
  {
    id: 4,
    question: "Гарантируется ли конфиденциальность?",
    answer: "Абсолютно. Конфиденциальность — основа психотерапевтической работы. Всё, что вы рассказываете на сессии, остаётся между нами. Я следую этическому кодексу психолога и законодательству о персональных данных."
  },
  {
    id: 5,
    question: "Можно ли отменить или перенести сессию?",
    answer: "Да, вы можете отменить или перенести сессию не менее чем за 24 часа до назначенного времени. При отмене менее чем за 24 часа взимается 50% стоимости сессии."
  },
  {
    id: 6,
    question: "Работаете ли вы с детьми?",
    answer: "Да, я специализируюсь на детской психологии и работаю с детьми от 5 лет. Использую игровые методы, арт-терапию и специальные техники для работы с детскими проблемами."
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.pexels.com/photos/5217850/pexels-photo-5217850.jpeg",
    title: "Комфортный кабинет",
    category: "Пространство"
  },
  {
    id: 2,
    url: "https://images.pexels.com/photos/5217852/pexels-photo-5217852.jpeg",
    title: "Зона для консультаций",
    category: "Пространство"
  },
  {
    id: 3,
    url: "https://images.pexels.com/photos/4098255/pexels-photo-4098255.jpeg",
    title: "Рабочее пространство",
    category: "Офис"
  },
  {
    id: 4,
    url: "https://images.pexels.com/photos/8376318/pexels-photo-8376318.jpeg",
    title: "Индивидуальная консультация",
    category: "Работа"
  },
  {
    id: 5,
    url: "https://images.pexels.com/photos/7641868/pexels-photo-7641868.jpeg",
    title: "Профессиональный подход",
    category: "Работа"
  },
  {
    id: 6,
    url: "https://images.pexels.com/photos/7176293/pexels-photo-7176293.jpeg",
    title: "Терапевтическая сессия",
    category: "Работа"
  }
];

export const serviceOptions = [
  { value: "primary", label: "Первичная консультация" },
  { value: "individual", label: "Индивидуальная консультация" },
  { value: "family", label: "Семейная консультация" },
  { value: "child", label: "Детская психология" },
  { value: "crisis", label: "Кризисная помощь" },
  { value: "suicide", label: "Суицидальный кризис" },
  { value: "online", label: "Индивидуальная консультация" },
  { value: "corporate", label: "Корпоративная психология" }
];
